import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ee435yr3t: FaireProductEntity = {
  token: "p_9ee435yr3t",
  type: "product",
  name: "Ojai Lavender - 12.5 oz Large Concentrated Candle",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/343bfd5dbb5044a9993ec73d9fb4dc41b640459fb971bc4c0c15980607a28b72.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f5735b18e74c642788ca7ca4ab4b39eda6c81e1839386d999ac55d630c4f5a0d.jpeg",
    "https://cdn.faire.com/fastly/afb19a6abc1e1b9fce2de2bed275a92447726136db56dd7795f5dc1b2e888bca.jpeg",
    "https://cdn.faire.com/fastly/f3a75cc6bf2918065f997158e498d7c0d74cd5ed18e2f3663ac17c203cf11ca5.jpeg",
    "https://cdn.faire.com/fastly/4ef6d419cdc9da7b526259b6216102c1888b253fc0b03b06b1476427b6a7c61b.jpeg",
    "https://cdn.faire.com/fastly/afbe679981c3d3e032816803c911acc1445fb493b8af6041a885784071de9717.jpeg",
    "https://cdn.faire.com/fastly/2c0513b366ce92444a1ba54c40ea2665868f10ed7e7aa4b35faecbd9760f7e3f.jpeg",
  ],
  priceDollars: 18,
  description:
    "Sun-drenched fields, orange groves and lavender farms, jagged mountains washed in a rosy, sunset glow. Pixie tangerine, lavender, mint.\n\nIntroducing our new and reformulated Large Concentrated Candles – we took our best-selling Classic Line scents and increased the fragrance level for stronger throw in your biggest spaces.\n\nOur 12.5 oz Large Candles are hand-poured into apothecary-inspired amber jars with our signature kraft label and a brass lid. \n\nOur candles are simple - they're all made with 100% domestically grown soy wax, fine fragrance oils, and cotton-core wicks. The fragrances we use are paraben-free, phthalate-free, and never (ever) tested on animals.\n\nBurns for 60-70 hours.",
  tags: [],
  msrpDollars: 37.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:52.563Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
